import { ApolloCache, FetchResult, Reference } from '@apollo/client';

import { IChangeHostResponse } from './schema';

export const updateChangeHostCache = (
  cache: ApolloCache<unknown>,
  { data }: FetchResult<IChangeHostResponse>
): void => {
  const clientSession = data?.changeClientSessionHost;
  if (!clientSession || clientSession.hosts.length < 2) return;

  const { hosts } = clientSession;
  const lastHost = hosts[hosts.length - 1].host;
  const previousHost = hosts[hosts.length - 2].host;
  const sessionRef = cache.identify({
    ...clientSession,
    __typename: 'ClientSessionOverview',
  });
  if (!sessionRef) return;

  cache.modify({
    id: cache.identify({ ...lastHost, __typename: 'HostOverview' }),
    fields: {
      counters(existingCounters: Record<string, unknown> = {}) {
        return {
          ...existingCounters,
          active_window: lastHost.counters.active_window,
        };
      },
      client_sessions(existingSessions: Reference[] = [], { toReference }) {
        const sessionReference = toReference(sessionRef);
        if (
          !existingSessions.some(({ __ref }) => __ref === sessionRef) &&
          sessionReference
        ) {
          return [...existingSessions, sessionReference];
        }
        return existingSessions;
      },
    },
  });

  cache.modify({
    id: cache.identify({ ...previousHost, __typename: 'HostOverview' }),
    fields: {
      counters(existingCounters: Record<string, unknown> = {}) {
        return {
          ...existingCounters,
          active_window: previousHost.counters.active_window,
        };
      },
      client_sessions(existingSessions: Reference[] = []) {
        return existingSessions.filter(({ __ref }) => __ref !== sessionRef);
      },
    },
  });
};
